import * as React from "react";
import Menu from "components/bootstrap/Menu";
import Button from "components/bootstrap/Button";
import { ButtonGroup } from "components/bootstrap/index";
import Icon from "../common/Icon";
const SplitButton = ({
  children,
  disabled = false,
  title,
  open = void 0,
  onMenuChange = void 0,
  width = void 0,
  onClick,
  dataTestId = void 0,
  ...props
}, ref) => /* @__PURE__ */ React.createElement(Menu, { opened: open, onChange: onMenuChange, width }, /* @__PURE__ */ React.createElement(ButtonGroup, { "data-testid": dataTestId }, /* @__PURE__ */ React.createElement(Button, { ...props, disabled, onClick }, title), /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(Button, { ref, "aria-label": "More Actions", ...props }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down" }))), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, children)));
export default React.forwardRef(SplitButton);
